import { render, staticRenderFns } from "./LmAdditionalInitiatorsNewOrEdit.vue?vue&type=template&id=e8266d42"
import script from "./LmAdditionalInitiatorsNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmAdditionalInitiatorsNewOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports